<template>
  <el-container direction="vertical" style="margin: 5vh 5vw">
    <process-log :isVisible.sync="showModal" :recordSelected="recordSelected" />
    <PdfModal :isVisible.sync="dateModal" @makePdf="makePdf" />
    <div class="header">
      <h2>Task: {{ currentTaskName }}</h2>
    </div>
    <div style="display: flex; align-items: center">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="height: 55px; line-height: 55px"
      >
        <el-breadcrumb-item :to="{ path: `/servers/${instanceId}/tasks` }"
          >Tasks</el-breadcrumb-item
        >
        <el-breadcrumb-item>History</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- <div style="flex-grow: 1"></div>
      <el-button
        class="button"
        @click="dateModal = true"
        style="
          text-align: center;
          padding: 18px;
          width: 125px;
          height: 40px;
          float: right;
          line-height: 15%;
        "
      >
        Download PDF</el-button
      > -->
    </div>
    <!-- <el-input v-model="filter" placeholder="Type to search" style="width: 30%; margin-bottom: 12px" /> -->
    <slider>
      <template #table>
        <taskTable
          v-if="itemsToShow.length > 0"
          ref="taskTable"
          @selectHistory="selectHistory"
          :itemsToShow="itemsToShow"
          :tableFormat="tableFormat"
        />
      </template>
      <template #details>
        <taskDetails
          ref="taskDetails"
          @tabClicked="tabClicked"
          @setShowModal="setShowModal"
          :showModal="showModal"
          :itemsToShow="itemsToShow"
          :activeTab="activeTab"
          :activeRecord="activeRecord"
          :historyDetails="historyDetails"
          :logData="logData"
        />
      </template>
    </slider>
  </el-container>
</template>

<script>
import ProcessLog from "../components/modals/ProcessLog";
import TaskService from "../services/TaskService";
import PdfModal from "../components/modals/DatePdf";
import taskDetails from "../components/TaskDetails.vue";
import slider from "../components/Draggable.vue";
import taskTable from "../components/TaskTable.vue";
import moment from "moment-timezone";
import { mapState } from "vuex";
import Helper from "../utilities/Helper";
import store from "../store/store";

export default {
  data() {
    return {
      showModal: false,
      dateModal: false,
      items: [],
      itemsToShow: [],
      filter: null,
      activeTab: "Details",
      activeRecord: {},
      tableFormat: [],
      historyDetails: {},
      logData: [],
      filterResultList: [],
      filterRunByList: [],
      filterDateList: [],
      recordSelected: null,
      pendingHistories: [],
      pendingIds: [],
      timer: "",
      timezone:
        process.env.VUE_APP_SERVER_TIMEZONE ||
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      resizer: document.getElementById("draggable"),
      leftSide: document.getElementById("left-side"),
      rightSide: document.getElementById("right-side"),
      mouseX: 0,
      mouseY: 0,
      leftWidth: 0,
      rightWidth: 0,
    };
  },
  components: { ProcessLog, taskDetails, slider, taskTable, PdfModal },
  watch: {
    filter(value) {
      let filter = value.toLowerCase();
      this.itemsToShow = this.items.filter((item) => {
        return JSON.stringify(item).toLowerCase().includes(filter);
      });
    },
  },
  computed: {
    ...mapState([
      "currentTaskName",
      "instanceId",
      "taskId",
      "isUserLoggedIn",
      "environmentId",
    ]),
  },
  methods: {
    handleError: Helper.handleError,
    async combineSingleCubeDims() {
      const sourceViewDims = this.historyDetails.source.taskHistoryDims.slice();
      const targetViewDims = this.historyDetails.target.taskHistoryDims.slice();

      const response = await TaskService.getCubeDims({
        cubeName: this.historyDetails.target.taskHistoryCube.name,
        instanceId: this.instanceId,
      });
      const targetCubeDims = response.data.dims.value;

      sourceViewDims.forEach((sourceDim) => {
        const foundInTargetViewDims = targetViewDims.find(
          (dim) => dim.name === sourceDim.name
        );
        if (!foundInTargetViewDims) {
          const foundInTargetCubeDims = targetCubeDims.find(
            (dim) => dim.Name === sourceDim.name
          );
          if (foundInTargetCubeDims) {
            const index = sourceViewDims.indexOf(sourceDim);
            this.historyDetails.target.taskHistoryDims[index] = sourceDim;
          }
        } else {
          const index = sourceViewDims.findIndex(
            (dim) => dim.name === foundInTargetViewDims.name
          );
          this.historyDetails.target.taskHistoryDims[index] =
            foundInTargetViewDims;
        }
      });
    },
    combineMultipleCubesDims() {
      const sourceViewDims = this.historyDetails.source.slice();
      const targetViewDims = this.historyDetails.target.slice();

      sourceViewDims.forEach((sourceDim) => {
        const found = targetViewDims.find((dim) => dim.name === sourceDim.name);
        if (!found) {
          const index = sourceViewDims.indexOf(sourceDim);
          this.historyDetails.target[index] = sourceDim;
        } else {
          const index = sourceViewDims.findIndex(
            (dim) => dim.name === found.name
          );
          this.historyDetails.target[index] = found;
        }
      });
    },
    async setShowModal() {
      this.showModal = true;
    },

    async selectHistory(row) {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        this.activeRecord = row;

        const detailsRepsonse = await TaskService.getHistoryDetails({
          taskHistoryId: this.activeRecord.id,
        });
        const taskHistoryDetails = detailsRepsonse.data.taskHistoryDetails;
        if (this.activeRecord.source === "Single Cube") {
          this.historyDetails = {
            source:
              taskHistoryDetails[0].taskHistoryCube.type === "source"
                ? taskHistoryDetails[0]
                : taskHistoryDetails[1],
            target:
              taskHistoryDetails[0].taskHistoryCube.type === "target"
                ? taskHistoryDetails[0]
                : taskHistoryDetails[1],
          };

          if (this.activeRecord.target !== "File")
            await this.combineSingleCubeDims();
        } else if (this.activeRecord.source === "Multiple Cubes") {
          this.historyDetails = {
            source: [],
            target: [],
          };

          for (let i = 0; i < taskHistoryDetails.length; i++) {
            if (taskHistoryDetails[i].type === "source") {
              this.historyDetails.source.push(taskHistoryDetails[i]);
            } else if (taskHistoryDetails[i].type === "target") {
              this.historyDetails.target.push(taskHistoryDetails[i]);
            }
          }

          this.combineMultipleCubesDims();
        } else if (this.activeRecord.source === "Value") {
          this.historyDetails = {
            target: taskHistoryDetails[0],
          };
        }

        this.logData = [];
        const logResponse = await TaskService.getLog({
          taskHistoryId: this.activeRecord.id,
        });
        for (const record of logResponse.data.log) {
          record.createdAt = moment(record.createdAt)
            .tz(this.timezone)
            .format("h:mm:ss A on LL");
          this.logData.push(record);
        }
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    async tabClicked(tab) {
      if (tab.name === "Log") {
        await this.updateLog();
      }
    },
    async updateLog() {
      this.logData = [];
      const logResponse = await TaskService.getLog({
        taskHistoryId: this.activeRecord.id,
      });
      for (const record of logResponse.data.log) {
        record.createdAt = moment(record.createdAt)
          .tz(this.timezone)
          .format("h:mm:ss A on LL");
        this.logData.push(record);
      }
    },
    async getHistory() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        const response = await TaskService.getHistory({
          taskId: this.taskId,
        });
        let setByResult = new Set();
        let setByRunBy = new Set();
        let setByDate = new Set();
        this.items = response.data.histories.map((history) => {
          const taskHistory = history.taskHistory;
          //gets all the data details for a task.
          taskHistory.duration =
            moment(taskHistory.updatedAt).diff(
              moment(taskHistory.createdAt),
              "seconds"
            ) + " seconds";
          taskHistory.createdAt = moment(taskHistory.createdAt)
            .tz(this.timezone)
            .format("h:mm:ss A on LL");
          taskHistory.runBy = history.runBy;
          taskHistory.jobName = history.job;
          taskHistory.taskName = this.currentTaskName;
          let date = taskHistory.createdAt.split("on ")[1];
          setByResult.add(taskHistory.result);
          setByRunBy.add(taskHistory.runBy);
          setByDate.add(date);

          if (taskHistory.result === "Pending") {
            this.pendingHistories.push(taskHistory);
            this.pendingIds.push(taskHistory.id);
          }
          return taskHistory;
        });
        //converts sets to arrays
        this.filterRunByList = Array.from(setByRunBy);
        this.filterResultList = Array.from(setByResult);
        this.filterDateList = Array.from(setByDate);
        //sorts array for the filter options
        this.filterRunByList.sort();
        this.filterResultList.sort();
        this.filterDateList
          .sort((a, b) => {
            return new Date(a) - new Date(b);
          })
          .reverse();
        //put the filter options into objs that would be accepted to it
        this.filterRunByList = this.filterRunByList.map((name) => {
          return { value: name, text: name };
        });
        this.filterDateList = this.filterDateList.map((name) => {
          return { value: name, text: name };
        });
        this.filterResultList = this.filterResultList.map((name) => {
          return { value: name, text: name };
        });
        this.itemsToShow = this.items;
        //table format is for how the table will look like and shows if it is filter
        //and sorted and which value it is
        this.tableFormat = [
          {
            prop: "result",
            label: "Result",
            filterOption: this.filterResultList,
            filterMethod: this.filterTaskResult,
            filterPlacement: "bottom-end",
          },
          {
            prop: "createdAt",
            label: "Started At",
            sortMethod: this.sortDate,
          },
          {
            prop: "duration",
            label: "Duration",
            sortMethod: this.sortDuration,
          },
          {
            prop: "runBy",
            label: "Run By",
            filterOption: this.filterRunByList,
            filterMethod: this.filterRunBy,
            filterPlacement: "bottom-end",
          },
        ];
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    async refreshTask() {
      try {
        if (this.pendingIds.length === 0) {
          this.cancelAutoUpdate();
          return;
        }

        if (
          this.pendingIds.indexOf(this.activeRecord.id) != -1 &&
          this.activeTab === "Log"
        ) {
          await this.renderLog();
        }

        const result = await TaskService.getHistoryResults();
        const finishedHistories = result.data.taskHistories;
        const finishedTotal = finishedHistories.length;
        let historyIndex;
        let resultTaskFilter = new Set();
        for (let i = 0; i < finishedTotal; i++) {
          historyIndex = this.pendingIds.indexOf(finishedHistories[i].id);
          if (historyIndex != -1) {
            this.pendingHistories[historyIndex].result = finishedHistories[
              i
            ].result
              .replace(/[A-Z]/g, " $&")
              .trim();
            this.pendingHistories[historyIndex].duration =
              moment(finishedHistories[i].updatedAt).diff(
                moment(finishedHistories[i].createdAt),
                "seconds"
              ) + " seconds";

            this.pendingHistories.splice(historyIndex, 1);
            this.pendingIds.splice(historyIndex, 1);
            resultTaskFilter.add(finishedHistories[i].result);
          }
          if (resultTaskFilter.size > 0) {
            //updates the filter of results if the result of the task changes
            this.filterResultList = Array.from(resultTaskFilter);
            this.filterResultList.sort();
            this.filterResultList = this.filterResultList.map((name) => {
              return { value: name, text: name };
            });
            let newTableFormat = this.tableFormat.slice();
            newTableFormat[0] = {
              prop: "result",
              label: "Result",
              filterOption: this.filterResultList,
              filterMethod: this.filterTaskResult,
              filterPlacement: "bottom-end",
            };
            this.tableFormat = newTableFormat;
          }
        }
      } catch (err) {
        this.cancelAutoUpdate();
        this.handleError(err, this, this.instanceId);
      }
    },
    async renderLog() {
      let container = this.$refs.logsTab;
      let scrollBottom = false;
      const currScroll = container.$el.scrollTop;

      if (
        currScroll + container.$el.clientHeight >=
        container.$el.scrollHeight
      ) {
        scrollBottom = true;
      }
      await this.updateLog();

      scrollBottom === true
        ? (container.$el.scrollTop = container.$el.scrollHeight)
        : (container.$el.scrollTop = currScroll);
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    async makePdf(dateRanges) {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        //gets date ranges from the modals
        let date1 = new Date(dateRanges[0]);
        let date2 = new Date(dateRanges[1]).setHours(23, 59, 59);
        //gets the table data to pass into the backend
        let filterData = this.$refs.taskTable.$refs.historyTable.tableData;
        let filterOptions =
          this.$refs.taskTable.$refs.historyTable.$refs.tableHeader.columns;
        //gets all of the filter options from the headers and sees if it is filtered
        let totalFilter = { result: [], startAt: [], duration: [], runBy: [] };
        for (let index = 0; index < filterOptions.length; index++) {
          //sees if there is a filter at the column then adds it based on the index
          if (filterOptions[index].filteredValue.length > 0) {
            for (let filterValue of filterOptions[index].filteredValue) {
              if (index == 0) {
                totalFilter.result.push(filterValue);
              } else if (index == 1) {
                totalFilter.startAt.push(filterValue);
              } else if (index == 2) {
                totalFilter.duration.push(filterValue);
              } else if (index == 3) {
                totalFilter.runBy.push(filterValue);
              }
            }
          }
        }
        //filters the table data based on the date from the modal then passes to the backend
        filterData = filterData.filter(
          (taskFilter) =>
            date1 - this.toFloatDate(taskFilter.createdAt) <= 0 &&
            date2 - this.toFloatDate(taskFilter.createdAt) >= 0
        );
        //reduces the filterData to only have ids and passes it forward
        let filterIds = filterData.map((data) => {
          return data.id;
        });

        TaskService.getFilteredHistoryDetails(
          filterIds,
          totalFilter,
          store.state.userId,
          dateRanges
        );
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    /**
     * The purpose: The purpose is to have a sorting algo for the custom sort.
     * @param {object} a is a object that has a duration
     * @param {object} b is a object that has a duration
     */
    sortDuration(a, b) {
      return (
        this.toFloatDuration(a.duration) - this.toFloatDuration(b.duration)
      );
    },
    toFloatDuration(num) {
      return parseFloat(num.replace(" seconds", ""));
    },
    /**
     * The purpose: The purpose is to have a sorting algo for the custom sort.
     * @param {object} a is a object that has a date
     * @param {object} b is a object that has a date
     */
    sortDate(a, b) {
      return this.toFloatDate(a.createdAt) - this.toFloatDate(b.createdAt);
    },
    toFloatDate(num) {
      let date = new Date(num.split(" on ").join(" "));
      return date;
    },
    /**
     * filter method for the table for run By
     * @param {string} value
     * @param {obj} row
     */
    filterRunBy(value, row) {
      return row.runBy === value;
    },
    /**
     * filter method for the table for result
     * @param {string} value
     * @param {obj} row
     */
    filterTaskResult(value, row) {
      return row.result === value;
    },
    /**
     * filter method for the table for dates but not needed
     * @param {string} value
     * @param {obj} row
     */
    filterDates(value, row) {
      let date = new Date(row.createdAt.split("on ")[1]);
      value = new Date(value);
      return date >= value;
    },
  },

  created() {
    this.timer = setInterval(this.refreshTask, 10000);
  },
  mounted() {
    if (!this.isUserLoggedIn) {
      this.$router.push({ name: "login" });
    } else if (!this.instanceId) {
      this.$router.push({ name: "servers" });
    } else {
      this.getHistory();
      this.dateModal = false;
    }
  },
  beforeDestroy() {
    if (this.taskId) this.$store.dispatch("setTaskId", null);
    if (this.currentTaskName) this.$store.dispatch("setCurrentTaskName", null);
    this.cancelAutoUpdate();
  },
};
</script>

<style scoped>
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
  padding: 10px 15px;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.card {
  font-size: 14px;
  color: #606266;
}
.el-card :deep(.el-card__header) {
  background-color: #f0f0f0;
  padding: 10px 20px;
}
.el-card :deep(.el-card__body) {
  padding: 10px 20px;
}
</style>
